// extracted by mini-css-extract-plugin
export var downArrow = "_9b-0";
export var infoTooltipIcon = "_9b-3";
export var label = "_9b-1";
export var optionCard = "_9b-4";
export var upArrow = "_9b-2";